<template>
  <div class="content-list" ref="listLength">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DropList",
  props: {
    // 一行满多少个后就加一行
    count: {
      type: Number,
      default: 5
    }
  },
  mounted() {
    let childCount = this.$refs.listLength.childElementCount;
    if (childCount > this.count) {
      let line = Math.ceil(childCount / this.count);
      this.$refs.listLength.style.width = 100 * line + "px";
    }
  }
};
</script>

<style lang="stylus" scoped>
.content-list
  width 100px
  position absolute
  left -10px
  background #1880f4
  z-index 10
  display flex
  flex-wrap wrap
  font-size 14px
  font-family 'Microsoft yahei'
</style>
